import { useQueryClient } from "@tanstack/react-query";
import { addTrackToProperty } from "../api";
import { AddTrackToPropertyDTO } from "../dtos";
import { Track } from "../types";
import { useDomainMutation } from "@/modules/common/hooks/domain-mutation.hook";

export function useAddTrackToProperty() {
  const queryClient = useQueryClient();

  const mutationAddTrack = useDomainMutation<
    Track,
    { response?: { data?: { message?: string } } },
    { uid: string; data: AddTrackToPropertyDTO }
  >({
    mutationFn: async ({
      uid,
      data,
    }: {
      uid: string;
      data: AddTrackToPropertyDTO;
    }) => {
      const response = await addTrackToProperty(uid, data);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["linked-tracks"] });
    },
  });

  return mutationAddTrack;
}
